/** Customer-facing copy for multi-league workspace context (no routing behavior). */

export const LEAGUE_WORKSPACE_LABEL = 'League workspace';
export const LEAGUE_SWITCHER_ARIA_LABEL = 'Switch league workspace';
export const LEAGUE_SWITCHER_PLACEHOLDER = 'Select a league';

export function leagueWorkspaceContextCopy(leagueCount: number, activeLeagueName?: string | null): string {
  if (leagueCount === 0) {
    return 'Create a league workspace to start setup, schedule sync, and archive review.';
  }
  if (leagueCount === 1) {
    const name = activeLeagueName?.trim();
    return name
      ? `You have one league workspace. Everything below applies to ${name}.`
      : 'You have one league workspace. Navigation and setup apply to this league only.';
  }
  const name = activeLeagueName?.trim();
  return name
    ? `You belong to ${leagueCount} league workspaces. Viewing ${name} — switch anytime without leaving Stream Center.`
    : `You belong to ${leagueCount} league workspaces. Pick a league to load its navigation and setup.`;
}

export function leagueSwitcherActiveLabel(
  leagueCount: number,
  activeLeagueName?: string | null
): string {
  if (leagueCount === 0) {
    return 'No leagues yet';
  }
  if (leagueCount === 1) {
    return activeLeagueName?.trim() || 'Your league';
  }
  return activeLeagueName?.trim() || LEAGUE_SWITCHER_PLACEHOLDER;
}

export function leagueSwitcherHelperCopy(leagueCount: number): string | null {
  if (leagueCount <= 1) {
    return null;
  }
  return 'Switch workspace';
}
